import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';
import { billingItemsActions } from './billingItemsReducer';

const initialState = {
  loading: false,
  providersList: [],
  providersListForHeader: []
};
const providers = createSlice({
  name: 'providers',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        providersList: action.payload?.result,
        count: action.payload?.count
      };
    },
    getProvidersListForHeader(state, action) {
      return {
        ...state,
        providersListForHeader: action.payload?.result,
        count: action.payload?.count
      };
    },
    getById(state, action) {
      return {
        ...state,
        providerInfo: action.payload
      };
    }
  }
});

export const providersActions = providers.actions;

export const getProvidersAction = (data) => async (dispatch) => {
  dispatch(providersActions.setLoading(true));
  try {
    const res = await api.post(`api/CompanyConnection/filter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(providersActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(providersActions.setLoading(false));
  }
};
export const getProvidersActionForHeader = (data) => async (dispatch) => {
  dispatch(providersActions.setLoading(true));
  try {
    const res = await api.post(`api/CompanyConnection/filter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(providersActions.getProvidersListForHeader(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(providersActions.setLoading(false));
  }
};

export const clearProviders = () => async (dispatch) => {
  dispatch(providersActions.getList([]));
};

export const createProvider = (data) => async () => {
  try {
    const res = await api.post(`api/CompanyConnection`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const editProvider = (data) => async () => {
  try {
    const res = await api.put(`api/CompanyConnection`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const getProviderById = (id) => async (dispatch) => {
  dispatch(providersActions.setLoading(true));
  try {
    const res = await api.get(`api/CompanyConnection`, { params: { id } });
    if (res.status === 200 && res?.data) {
      dispatch(providersActions.getById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(providersActions.setLoading(false));
  }
};

export const clearProviderById = () => async (dispatch) => {
  dispatch(providersActions.getById(''));
};

export const removeProviderAction = (id, setDialog) => async () => {
  try {
    const res = await api.delete(`api/CompanyConnection`, { params: { id } });
    if (res.status === 200) {
      setDialog('');
      toast.success('Removed successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const resendProviderAction = (id, setDialog) => async () => {
  try {
    const res = await api.post(`api/CompanyConnection/resend`, { id });
    if (res.status === 200) {
      setDialog('');
      toast.success('Action successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const deactivateProviderAction = (id, setDialog) => async () => {
  try {
    const res = await api.post(`api/CompanyConnection/deactivate`, { id });
    if (res.status === 200) {
      setDialog('');
      toast.success('Action successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const activateProviderAction = (id, setDialog) => async () => {
  try {
    const res = await api.post(`api/CompanyConnection/activate`, { id });
    if (res.status === 200) {
      setDialog('');
      toast.success('Action successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export default providers.reducer;
